<div class="viewer-body">
    <!-- Cover only for desktop -->    
    <div *ngIf="!(device$ | async).isMobile" class="cover" [ngClass]="{'displayed': !!(preview$ | async) }">
        <app-cover class="app-cover" 
            [device]="device$ | async"
            [preview]="preview$ | async" 
            [files]="files$ | async"
            [filesReady]="filesReady"
            [countryCode]="countryCode$ | async" 
            [isDownloading]="(downloadSectionDisplayed$ | async)"
            [countdownDisplayed]="!snackbarDisplayed" 
            (triggerCoverCLick)="resolveCoverClickAction()">
        </app-cover>
        <div class="content-overlay" [ngClass]="{'active': scrolledToPreview === true}"></div>
    </div>
    <div class="default-background-password-required" *ngIf="(passwordRequired$ | async) || (accessTrackingRequired$ | async)"></div>

    <!-- Preview -->
    <div [ngClass]="{'disable-scroll': !!(previewModalDisplayed$ | async) }" 
        *ngIf="!!(preview$ | async) && !(previewIsInQueue$ | async) && (!(downloadSectionDisplayed$ | async) || ((downloadSectionDisplayed$ | async) && (device$ | async)?.isMobile))">
        <div cdkScrollable 
            infinite-scroll
            [infiniteScrollDistance]="2"
            (scrolled)="nextBatch()"> 
            <div class="container-space"  [ngClass]="{'mobile': (device$ | async).isMobile }">
                <!-- Space for scroll -->
            </div>
            <app-preview
                class="preview" 
                [preview]="preview$ | async" 
                [files]="files$ | async" 
                [device]="device$ | async"
                [snackbarDisplayed]="snackbarDisplayed" 
                (unscrollPreview)="unscroll($event)">
            </app-preview>

        </div>           
    </div>

    <app-modal-preview 
            *ngIf="previewModalDisplayed$ | async" 
            [preview]="preview$ | async"
            [file]="selectedModalFile$ | async"
            [initialFileOffset]="initialFileOffset$ | async" 
            [files]="files$ | async" 
            [device]="device$ | async"
            (onClose)="scrollToFile($event)"
            (onDownloadFile)="download($event)">
            </app-modal-preview>

    <app-smash-snackbar class="snackbar" [ngClass]="{'visible': snackbarDisplayed}" *ngIf="(device$ | async)?.isDesktop && !!(preview$ | async)">
        <div class="viewer-snackbar-content">
            <div class="viewer-snackbar-content-left">
                <span class="viewer-snackbar-text-number-file" translate
                    [translateParams]="{ count: (selectedFiles$|async).length || (preview$ | async).transfer.filesNumber }">VIEWER_FILES</span>
                <span class="viewer-snackbar-text-size">({{(selectedFilesTotalSize$ | async) || (preview$ |
                    async).transfer.size |
                    bytes:2}})</span>
            </div>
            <ng-container *ngIf="!!(files$ | async) && snackbarDisplayed">
                <div class="viewer-snackbar-content-right">
                    <button class="btn-v3 primary" *ngIf="(selectedFiles$ | async)?.length" (click)="download()">
                        {{ 'VIEWER_SNACKBAR_BUTTON_LABEL_DOWNLOAD' | translate }}
                        ({{(selectedFiles$|async).length}})
                    </button>
                    <button class="btn-v3 primary" *ngIf="(selectedFiles$ | async)?.length === 0" (click)="download()">
                        {{ 'VIEWER_SNACKBAR_BUTTON_LABEL_DOWNLOAD_ALL' | translate }}
                    </button>
                </div>
            </ng-container>
        </div>
    </app-smash-snackbar>

    <div #iframe class="iframe"></div>  
</div>


<app-cgu-cookie-container template="VIEWER"></app-cgu-cookie-container>